
export const clients = [
  {
    id: 1,
    companyName: '阿里巴巴集团',
    industry: '互联网',
    scale: '10000+',
    location: '杭州',
    contactPerson: '刘总',
    phone: '13800138001',
    email: 'liu@alibaba.com',
    address: '浙江省杭州市余杭区文一西路969号',
    cooperationStatus: '长期合作',
    projectCount: 15,
    lastContact: '2024-01-15',
    description: '国内领先的电商平台公司，业务涵盖电商、云计算、数字娱乐等多个领域'
  },
  {
    id: 2,
    companyName: '腾讯科技',
    industry: '互联网',
    scale: '5000-10000',
    location: '深圳',
    contactPerson: '王经理',
    phone: '13800138002',
    email: 'wang@tencent.com',
    address: '广东省深圳市南山区科技园腾讯大厦',
    cooperationStatus: '活跃合作',
    projectCount: 12,
    lastContact: '2024-01-14',
    description: '中国领先的互联网增值服务提供商，社交网络服务和游戏业务领军企业'
  },
  {
    id: 3,
    companyName: '字节跳动',
    industry: '互联网',
    scale: '10000+',
    location: '北京',
    contactPerson: '张总监',
    phone: '13800138003',
    email: 'zhang@bytedance.com',
    address: '北京市海淀区知春路63号卫星大厦',
    cooperationStatus: '新客户',
    projectCount: 3,
    lastContact: '2024-01-13',
    description: '全球化的移动互联网公司，旗下产品包括抖音、今日头条等知名应用'
  },
  {
    id: 4,
    companyName: '美团',
    industry: '互联网',
    scale: '1000-5000',
    location: '北京',
    contactPerson: '李主管',
    phone: '13800138004',
    email: 'li@meituan.com',
    address: '北京市朝阳区望京东路6号美团总部',
    cooperationStatus: '潜在客户',
    projectCount: 1,
    lastContact: '2024-01-12',
    description: '中国领先的生活服务电子商务平台，涵盖外卖、酒店、旅游等多个业务'
  }
];
